import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { MobileActions } from './components/MobileActions';
import Home from './pages/Home';
import RedesignedHome from './pages/RedesignedHome';
import Contact from './pages/Contact';
import About from './pages/About';
import Services from './pages/Services';
import { SectionNavigation } from './components/SectionNavigation';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SectionNavigation />
        <Navbar />
        <main id="main-content" data-testid="main-content">
        <Routes>
          <Route path="/" element={<RedesignedHome />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/why-choose-us" element={<Home />} />
          <Route path="/gallery" element={<Home />} />
          <Route path="/faqs" element={<Home />} />
        </Routes>
        </main>
        <Footer />
        <MobileActions />
        <Toaster theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;